const cqcrating = [
    {
        "size": "",
        "style": "",
        "class": "",
        "children": [
            {
                "type": "topbar",
                "size": "12",
                "style": "",
                "class": "px-4",
                "title": 'CQC Rating',
            },
            {
                "type": "tabs",
                "size": "8",
                "style": "",
                "class": "pr-4",
                "children": [
                    {
                        "title": "CQC Rating",
                        "service": "category",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": false,
                            "deleteButton": false, 
                            "updateSuccessTitle": 'Category Updated!',
                            "updateSuccessMessage": 'Category Updated Successfully!',
                            "updateErrorTitle": 'Category Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                        },
                        "children": [
                            {
                                "type": "onlineServicesTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0",
                                "list": {
                                    "type": "list",
                                    "size": "4",
                                    "style": "",
                                    "class": "p-2",
                                    "empty": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "min-height: calc(100vh - 144px)",
                                    "class": "pl-3 pt-3",
                                    "form": {
                                        "url": {
                                            "type": 'text',
                                            "label": 'URL',
                                            "placeholder": 'Enter URL',
                                            "required": true,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        }
                                    },
                                    "children": [
                                    ]
                                }
                            },                            
                        ]
                    },
                ]
            },

        ]
    }
]

export { cqcrating };